import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { SelectSectionModule } from '../shared/components/select-section/select-section.module';
import { SharedModule } from '../shared/shared.module';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { NewHeaderComponent } from './components/new-header/new-header.component';
import { ReloadDataComponent } from './components/reload-data/reload-data.component';
import { SidebarMenuItemComponent } from './components/sidebar-menu/sidebar-menu-item/sidebar-menu-item.component';
import { SidebarMenuComponent } from './components/sidebar-menu/sidebar-menu.component';

@NgModule({
    declarations: [HeaderComponent, EmptyStateComponent, SidebarMenuComponent, SidebarMenuItemComponent, LoginComponent, FooterComponent, ReloadDataComponent, NewHeaderComponent],
    imports: [FormsModule, CommonModule, HttpClientModule, RouterModule, BrowserAnimationsModule, SharedModule, SelectSectionModule],
    providers: [],
    exports: [HeaderComponent, EmptyStateComponent, NewHeaderComponent, SidebarMenuComponent, LoginComponent, FooterComponent, HttpClientModule,ReloadDataComponent]
})
export class CoreModule {}
